import React from 'react';
import { formatTrackLabel } from '../../../logic/track';

const CHANGE_HINT = "Track is set by the patient's care pathway. To change it, open the Care Plan tab and switch the care pathway.";

// The patient's ACCESS track + resolved subtrack (e.g. "eCKM · ECKM-04"). Hover
// (or focus) reveals where the track can be changed (Care Plan → Change pathway).
// 'sm' stacks two of these to the care-period ring's exact height in the patient-file header.
const SIZE = {
  md: { fontSize: 11, padding: '2px 8px' },
  sm: { fontSize: 10, lineHeight: '14px', padding: '3px 8px' },
};

export default function TrackBadge({ trackCode, subtrackId, style, size = 'md' }) {
  const track = formatTrackLabel(trackCode, subtrackId);
  if (!track && !subtrackId) return null;
  const label = [track?.code, subtrackId].filter(Boolean).join(' · ');
  const hint = `${track?.display || 'ACCESS track'}${subtrackId ? ` — subtrack ${subtrackId}` : ''}. ${CHANGE_HINT}`;
  return (
    <span
      className="wi-tip"
      data-tip={hint}
      role="note"
      aria-label={hint}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        fontWeight: 600, borderRadius: 20, ...SIZE[size],
        background: 'var(--wi-background-tertiary)', color: 'var(--wi-text-secondary)',
        letterSpacing: '0.02em', cursor: 'help',
        ...(style || {}),
      }}
    >
      {label}
    </span>
  );
}
